import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { palette } from '../../../Dashboard.styled';

export const HeaderImage = styled.img`
  display: block;
  width: 100%;
  max-height: 260px;
  object-fit: cover;
`;

export const Body = styled.div`
  padding: 20px 24px 24px;
`;

export const Tag = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  background: ${palette.green};
  color: ${colors.WHITE};
`;

export const Title = styled.h2`
  margin: 10px 0 4px;
  font-size: 20px;
  font-weight: 700;
  color: ${palette.ink};
`;

export const DateLabel = styled.p`
  margin: 0 0 14px;
  font-size: 12px;
  color: ${palette.muted};
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: ${colors.WHITE};
  color: ${palette.ink};
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(16, 24, 40, 0.2);
`;
